import {
  Component,
  OnInit,
  Input,
  forwardRef,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
  Renderer2,
} from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { Router } from "@angular/router";

@Component({
  selector: "app-dynamic-dropdown",
  templateUrl: "./dynamic-dropdown.component.html",
  styleUrls: ["./dynamic-dropdown.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DynamicDropdownComponent),
      multi: true,
    },
  ],
})
export class DynamicDropdownComponent implements OnInit {
  @Input() public invalid: string;
  @Input() public change;
  @Input() public required: string;
  @Input() public optional: string;
  @Input() public myLabel = "";
  @Input() public value;
  @Input() public id = "";
  @Input() public optionCollection;
  @Input() public optionViewProperty;
  @Input() public optionValueProperty;

  onTouched = () => {};
  onChange = (_) => {};
  @ViewChild("input", { static: true, read: ElementRef })
  public dropdownElementRef: ElementRef;
  @Input() public animate: boolean = false;
  public contributor: boolean;
  public now: boolean;
  public future: boolean;
  public never: boolean;
  public href: string = "";
  public currentSection: string;
  public capitalize: boolean = false;
  constructor(private _renderer: Renderer2, private router: Router) {}
  @Output("focusout") public focusOutEmitter: EventEmitter<any> =
    new EventEmitter();
  @Output("change") public changeEmitter: EventEmitter<any> =
    new EventEmitter();

  ngOnInit() {
    this.href = this.router.url;
    switch (this.href) {
      case "/dynamicformdataentry/delegate_3_1":
        this.currentSection = "assets";
        console.log('currentSection', this.currentSection)
        break;
      case "/dynamicformdataentry/delegate_3_2":
        this.currentSection = "debts";
        console.log('currentSection', this.currentSection)
        break;
      case "/dynamicformdataentry/delegate_3_3":
        this.currentSection = "daily life";
        console.log('currentSection', this.currentSection)
        break;
      case "/dynamicformdataentry/delegate_3_5":
        this.currentSection = "digital life";
        console.log('currentSection', this.currentSection)
        break;
      case "/dynamicformdataentry/delegate_3_4":
        this.currentSection = "wishes";
        console.log('currentSection', this.currentSection)
        break;
    }
    if (this.dropdownElementRef.nativeElement.value) {
      this.animate = true;
    } else {
      this.animate = false;
    }
  }

  passOnChange(event: any) {
    this.changeEmitter.emit(event);
  }

  onDropdownChange() {
    const value = this.dropdownElementRef.nativeElement.value;
    if (value) {
      this.animate = true;
    } else {
      this.animate = false;
    }
    switch (value) {
      case "contributor":
        this.contributor = true;
        this.now = false;
        this.future = false;
        this.never = false;
        break;
      case "now":
        this.contributor = false;
        this.now = true;
        this.future = false;
        this.never = false;
        break;
      case "future":
        this.contributor = false;
        this.now = false;
        this.future = true;
        this.never = false;
        break;
      case "never":
        this.contributor = false;
        this.now = false;
        this.future = false;
        this.never = true;
        break;
    }
    this.handleLabel();
    this.onChange(value);
  }

  onBlur() {
    this.onTouched();
    this.focusOutEmitter.emit();
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  writeValue(value: string) {
    this._renderer.setProperty(
      this.dropdownElementRef.nativeElement,
      "value",
      value
    );
  }

  setDisabledState(isDisabled: boolean): void {
    this._renderer.setProperty(
      this.dropdownElementRef.nativeElement,
      "disabled",
      isDisabled
    );
  }
  handleLabel() {
    if (this.dropdownElementRef.nativeElement.value) {
      this.animate = true;
    } else {
      this.animate = false;
    }
  }
}
